import { Check } from 'lucide-react';

import type { Configuracao } from '@/api/secretario';
import { Button } from '@/components/ui/button';
import { CollapsibleCard } from '@/components/ui/CollapsibleCard';

import { DocumentosRequeridosEditor } from './DocumentosRequeridosEditor';
import { QuestionarioEditor } from './QuestionarioEditor';

interface BaseUniversalCardProps {
  config: Configuracao;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** O usuário marcou a base como finalizada (mostra check no resumo). */
  concluida?: boolean;
  /** Chamado ao concluir (o pai colapsa o card). */
  onConcluir?: () => void;
}

/**
 * Documentos e perguntas BASE (nível da configuração) — valem para todas as
 * áreas. Cada item já é salvo ao adicionar/remover; o botão "Concluir" apenas
 * sinaliza que o usuário terminou (colapsa o card + check no resumo).
 */
export function BaseUniversalCard({ config, open, onOpenChange, concluida, onConcluir }: BaseUniversalCardProps) {
  const contagens = `${config.documentos_base.length} documentos · ${config.perguntas_base.length} perguntas`;
  const summary = concluida ? (
    <span className="flex items-center gap-1 text-emerald-600">
      <Check size={14} /> {contagens}
    </span>
  ) : (
    contagens
  );

  return (
    <CollapsibleCard
      title="Documentos e perguntas base"
      summary={summary}
      open={open}
      onOpenChange={onOpenChange}
    >
      <p className="text-sm text-muted-foreground">
        Valem para todas as áreas (ex.: identidade e comprovante de residência do cliente). Itens com condição
        só são solicitados se a condição se aplicar ao caso.
      </p>
      <DocumentosRequeridosEditor escopo={{ tipo: 'base' }} documentos={config.documentos_base} />
      <QuestionarioEditor escopo={{ tipo: 'base' }} perguntas={config.perguntas_base} />
      <div className="flex justify-end">
        <Button type="button" variant="outline" onClick={onConcluir}>
          Concluir
        </Button>
      </div>
    </CollapsibleCard>
  );
}
